export interface ValueReference {
  type: 'valueReference';
  path: string;
}

export function isValueReference(value: unknown): value is ValueReference {
  return (value as ValueReference)?.type === 'valueReference';
}
